import { EditParamsButtonComponent } from './edit-params-button.component';

export const EditParamsButton = EditParamsButtonComponent;
